import {
  Component,
  ElementRef,
  Inject,
  Input,
  LOCALE_ID,
  OnChanges,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';

import { DataAccessPostsPageFacade } from '@planone/bau365/data-access-fair-data';
import { WatchlistPageContext } from '@planone/bau365/data-access-user';
import { ShareFacade } from '@planone/bau365/feature-tracking';
import { EntityType, ExhibitorCardData, PostCardData } from '@planone/bau365/util-fair-data';
import { ModalBottomsheetHelper, ModalBottomsheetType, ShareButtonsHelper } from '@planone/shared/ui-elements';
import { localizedMeta } from '@planone/shared/util-meta';
import { ImageFileTypes } from '@planone/shared/util-pipelines';

@Component({
  selector: 'bau365-post-card',
  templateUrl: './post-card.component.html',
  styleUrls: ['./post-card.component.scss'],
})
export class PostCardComponent implements OnChanges {
  @Input()
  item: PostCardData | undefined;

  @Input()
  fairId: string | undefined;

  @Input()
  exhibitor: ExhibitorCardData | undefined;

  @Input()
  pageContext: WatchlistPageContext | undefined;

  @Input()
  size: string | undefined | null;

  @Input()
  markAsNew: boolean | undefined;

  url: string | undefined;
  startDateFormat: string | undefined;
  EntityType = EntityType;
  emailSubject = localizedMeta['shareEmailSubject'];
  emailBody = localizedMeta['shareEmailBody'];
  ImageFileTypes = ImageFileTypes;

  @ViewChild('title') title?: ElementRef;
  @ViewChild('shareButtonsTitle') public shareButtonsTitle: TemplateRef<never> | null | undefined;
  @ViewChild('shareButtons') public shareButtons: TemplateRef<never> | null | undefined;

  private get galleryImage() {
    return this.item?.gallery?.[0];
  }

  get displayImage() {
    return this.galleryImage ?? this.item?.hero_image;
  }

  constructor(
    @Inject(LOCALE_ID) private localeId: string,
    private shareButtonsHelper: ShareButtonsHelper,
    private modalBottomsheetHelper: ModalBottomsheetHelper,
    private PostsPageFacade: DataAccessPostsPageFacade,
    private trackingShareFacade: ShareFacade
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['item']) {
      const baseUrl = `fairs/${this.item?.fair_id}/posts/`;
      this.url = this.shareButtonsHelper.buildShareUrlFromPath(
        baseUrl + encodeURIComponent(changes['item'].currentValue.id)
      );
      this.emailBody += $localize`:@@postCard-emailShare-entityType-post:Beitrag ${this.item?.headline}`;
    }
    if (changes['size']) {
      if (changes['size'].currentValue === 'phone') {
        this.startDateFormat = 'MM.dd.yy hh:mm';
      } else {
        this.startDateFormat = 'MM.dd.yyyy hh:mm';
      }
    }
  }

  openShareButtonDialog(event: Event) {
    event.preventDefault();
    event.stopPropagation();

    if (this.pageContext && this.fairId && this.item && this.exhibitor) {
      this.PostsPageFacade.shareDialogOpened('POST', this.pageContext, this.fairId, this.item);

      this.trackingShareFacade.open({
        entityType: 'POST',
        pageType: this.pageContext,
        context: this.fairId,
        entities: {
          post: this.item,
          exhibitor: this.exhibitor,
        },
      });
    }

    this.modalBottomsheetHelper.openDialog(
      ModalBottomsheetType.share,
      this.shareButtonsTitle,
      this.shareButtons,
      this.size
    );
  }

  shareButtonClick(network: string) {
    if (this.item && this.exhibitor && this.pageContext && this.fairId) {
      this.PostsPageFacade.shareButtonClicked(
        network,
        this.item,
        this.exhibitor?.display_name ?? this.exhibitor?.name ?? '',
        this.pageContext,
        this.fairId
      );

      this.trackingShareFacade.click({
        entityType: 'POST',
        pageType: this.pageContext,
        context: this.fairId,
        network: network,
        entities: {
          post: this.item,
          exhibitor: this.exhibitor,
        },
      });
    }
  }
}
